import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BreadcrumbsBg from "../Assets/img/breadcrumbs-bg.png";

const NoticeBorad = () => {
  const [notices, setNotices] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get("JSON/notice.json").then((response) => {
      setNotices(response.data.reverse());
    });
  }, []);

  return (
    <>
      <section
        className="eschool-breadcrumbs"
        style={{ backgroundImage: `url(${BreadcrumbsBg})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="eschool-breadcrumbs-content">
                <h3 className="eschool-bread-cont-title">Notice Board</h3>
                <ul className="eschool-bread-menu">
                  <li>
                    <Link to="/">Home</Link>
                    <i class="fi fi-br-angle-right"></i>
                  </li>
                  <li className="active">
                    <Link to="/noticeboard">Notice Board</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="eschool-notice-board">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-xl-10 offset-xl-1 col-12">
              <div className="eschool-notice-board-inner">
                <div className="notice-board-top">
                  <div className="row align-items-center">
                    <div className="col-lg-4 col-12">
                      <div className="notice-board-top-search">
                        <form action="#" method="post">
                          <input
                            type="search"
                            placeholder="Search notice"
                            required
                          />
                        </form>
                      </div>
                    </div>
                    <div className="col-lg-8 col-12">
                      <div className="notice-board-top-select">
                        <div className="notice-borad-single-select show-item">
                          <label>Show item:</label>
                          <select
                            className="form-select"
                            aria-label=".form-select-lg example"
                          >
                            <option selected>20</option>
                            <option value="1">50</option>
                            <option value="2">100</option>
                          </select>
                        </div>
                        <div className="notice-borad-single-select sort-by">
                          <label>Sort by:</label>
                          <select
                            className="form-select "
                            aria-label=".form-select-lg example"
                          >
                            <option selected>Name</option>
                            <option value="1">Date</option>
                            <option value="2">Latest notice</option>
                            <option value="3">Oldest notice</option>
                            <option value="4">This month</option>
                            <option value="5">This year</option>
                          </select>
                        </div>
                        <div className="notice-borad-single-select category">
                          <label>Category:</label>
                          <select
                            className="form-select "
                            aria-label=".form-select-lg example"
                          >
                            <option selected>Holiday</option>
                            <option value="1">Gov't holiday</option>
                            <option value="2">Education related</option>
                            <option value="3">Exam related</option>
                            <option value="4">Class related</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="eschool-notice-board-data">
                  <div className="notice-board-data-top">
                    <span className="date-time">Date & time </span>
                    <span className="notice-details">Notice details</span>
                    <span className="action">Action</span>
                  </div>
                  <div className="notice-board-data-main">
                    {notices?.map((notice) => (
                      <div className="notice-board-data-single" key={notice.id}>
                        <span className="date-data">
                          {notice?.date}, {notice?.time}
                        </span>
                        <span className="notice-data">{notice?.title}</span>
                        <span className="action-btns">
                          <a href={notice?.file} target="blank">
                            <i class="fi fi-rr-eye"></i>
                          </a>
                          <a href={notice?.file} download>
                            <i class="fi fi-sr-download"></i>
                          </a>
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="eschool-notice-board-bottom">
                  <div className="notice-board-bottom-button">
                    <Link to="#" className="single-btn prev-btn">
                      <i class="fi fi-rr-arrow-left"></i>Previous Page
                    </Link>
                    <Link to="#" className="single-btn next-btn">
                      Next Page<i class="fi fi-rr-arrow-right"></i>
                    </Link>
                  </div>
                  <div className="notice-board-btm-page-number">
                    <form action="#" method="post">
                      <p>
                        Page <input type="text" placeholder="1" required /> of
                        100
                      </p>
                      <button
                        type="submit"
                        className="notice-btm-page-number-btn"
                      >
                        Go
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NoticeBorad;
